// extracted by mini-css-extract-plugin
module.exports = {"container":"Message_container__1oZBM","messageText":"Message_messageText__2TYjU","show":"Message_show__1wypI"};